export enum OrderAction {
  ORDER_INITIATE = 'ORDER_INITIATE',
  ORDER_ASSIGN_ORDER_TYPE = 'ORDER_ASSIGN_ORDER_TYPE',
  ORDER_ASSIGN_TABLE = 'ORDER_ASSIGN_TABLE',
  ORDER_SET_SPEND_LIMIT = 'ORDER_SET_SPEND_LIMIT',
  ORDER_ASSIGN_TABLES = 'ORDER_ASSIGN_TABLES',
  ORDER_TABLE_CHECK = 'ORDER_TABLE_CHECK',
  ORDER_UPDATE_ORDER_NOTES = 'ORDER_UPDATE_ORDER_NOTES',
  ORDER_UPDATE_FULFILMENT_DETAIL = 'ORDER_UPDATE_FULFILMENT_DETAIL',
  ORDER_ASSIGN_STAFF = 'ORDER_ASSIGN_STAFF',
  ORDER_ASSIGN_CUSTOMER = 'ORDER_ASSIGN_CUSTOMER',
  ORDER_UPDATE_DUE_AT = 'ORDER_UPDATE_DUE_AT',
  ORDER_UPDATE_REQUIRED_AT = 'ORDER_UPDATE_REQUIRED_AT',
  ORDER_UPDATE_FULFILMENT_METADATA = 'ORDER_UPDATE_FULFILMENT_METADATA',
  ORDER_REMOVE_FULFILMENT_METADATA = 'ORDER_REMOVE_FULFILMENT_METADATA',
  ORDER_REMOVE_FULFILMENT_DETAIL = 'ORDER_REMOVE_FULFILMENT_DETAIL',
  ORDER_UPDATE_CUSTOMER = 'ORDER_UPDATE_CUSTOMER',
  ORDER_UNASSIGN_CUSTOMER = 'ORDER_UNASSIGN_CUSTOMER',
  ORDER_UNASSIGN_TABLE = 'ORDER_UNASSIGN_TABLE',
  ORDER_ASSIGN_NAME = 'ORDER_ASSIGN_NAME',
  ORDER_TRANSFER = 'ORDER_TRANSFER',
  ORDER_PRINT = 'ORDER_PRINT',
  ORDER_EMAIL_RECEIPT = 'ORDER_EMAIL_RECEIPT',
  ORDER_ADD_DISCOUNT = 'ORDER_ADD_DISCOUNT',
  ORDER_ASSIGN_RESERVATION = 'ORDER_ASSIGN_RESERVATION',
  ORDER_UNASSIGN_RESERVATION = 'ORDER_UNASSIGN_RESERVATION',
  ORDER_ADD_ADJUSTMENT = 'ORDER_ADD_ADJUSTMENT',
  ORDER_REMOVE_ADJUSTMENTS = 'ORDER_REMOVE_ADJUSTMENTS',
  ORDER_PAYMENT = 'ORDER_PAYMENT',
  ORDER_PAYMENT_PROCESSED = 'ORDER_PAYMENT_PROCESSED',
  ORDER_ADD_TIP = 'ORDER_ADD_TIP',
  ORDER_UPDATE_TIP = 'ORDER_UPDATE_TIP',
  ORDER_SAVE = 'ORDER_SAVE',

  ORDER_VOID = 'ORDER_VOID',
  ORDER_REFUND = 'ORDER_REFUND',
  ORDER_UPDATE_LAST_CHECK = 'ORDER_UPDATE_LAST_CHECK',
  ORDER_FAIL = 'ORDER_FAIL',
  ORDER_UPDATE_ADJUSTMENTS = 'ORDER_UPDATE_ADJUSTMENTS',
  ORDER_ITEMS_UPDATE_ADJUSTMENT = 'ORDER_ITEMS_UPDATE_ADJUSTMENT',

  ORDER_ITEM_ADD = 'ORDER_ITEM_ADD',
  ORDER_ITEM_REMOVE = 'ORDER_ITEM_REMOVE',
  ORDER_ITEM_ADD_NOTES = 'ORDER_ITEM_ADD_NOTES',
  ORDER_ITEM_UPDATE_PRICE = 'ORDER_ITEM_UPDATE_PRICE',
  ORDER_ITEM_UPDATE_QUANTITY = 'ORDER_ITEM_UPDATE_QUANTITY',
  ORDER_ITEM_HOLD = 'ORDER_ITEM_HOLD',
  ORDER_ITEM_ADD_MODIFIER = 'ORDER_ITEM_ADD_MODIFIER',
  ORDER_ITEM_REMOVE_MODIFIER = 'ORDER_ITEM_REMOVE_MODIFIER',
  ORDER_ITEM_UPDATE_MODIFIER_QUANTITY = 'ORDER_ITEM_UPDATE_MODIFIER_QUANTITY',
  ORDER_ITEM_PRINT = 'ORDER_ITEM_PRINT',
  ORDER_ITEM_TRANSFER = 'ORDER_ITEM_TRANSFER',
  ORDER_ITEM_REFUND = 'ORDER_ITEM_REFUND',
  ORDER_REPLACE_VARIANT = 'ORDER_REPLACE_VARIANT',
  ORDER_SWITCH_COURSE_ITEM = 'ORDER_SWITCH_COURSE_ITEM',
  ORDER_ITEM_SPLIT_QUANTITY = 'ORDER_ITEM_SPLIT_QUANTITY',

  ORDER_ITEM_ADD_COMBO = 'ORDER_ITEM_ADD_COMBO',
  ORDER_ITEM_SHOW_UPSELL_COMBOS = 'ORDER_ITEM_SHOW_UPSELL_COMBOS',

  // ORDER REWARD
  ORDER_REWARD_ADD = 'ORDER_REWARD_ADD',
  ORDER_REWARD_REMOVE = 'ORDER_REWARD_REMOVE',
  ORDER_REWARD_UPDATE_QUANTITY = 'ORDER_REWARD_UPDATE_QUANTITY',
  ORDER_REWARD_RESET = 'ORDER_REWARD_RESET',
  ORDER_REWARD_ADD_SNAPSHOT = 'ORDER_REWARD_ADD_SNAPSHOT',

  // VOUCHER REDEMPTION
  ORDER_ADD_VOUCHER = 'ORDER_ADD_VOUCHER',
  ORDER_REMOVE_VOUCHER = 'ORDER_REMOVE_VOUCHER',

  // Retrofit, TODO: Remove once POS App is cleaned up
  ORDER_ADD_VARIANT = 'ORDER_ADD_VARIANT',
  ORDER_SELECT_CART_PRODUCT = 'ORDER_SELECT_CART_PRODUCT',
  ORDER_DESELECT_CART_PRODUCT = 'ORDER_DESELECT_CART_PRODUCT',

  // Allergens
  ORDER_SET_ALLERGENS = 'ORDER_SET_ALLERGENS',

  // Used to send order sale receipt email to customer's email address
  CUSTOMER_NOTIFICATION = 'CUSTOMER_NOTIFICATION',
  ORDER_REFUND_INITIATE = 'ORDER_REFUND_INITIATE',
  ORDER_REFUND_PAYMENT = 'ORDER_REFUND_PAYMENT',
  ORDER_REFUND_ITEMS = 'ORDER_REFUND_ITEMS',
  ORDER_REFUND_AMOUNT = 'ORDER_REFUND_AMOUNT',
  ORDER_REFUND_UPDATE = 'ORDER_REFUND_UPDATE',
  ORDER_ASSIGN_REFUND_REASON = 'ORDER_ASSIGN_REFUND_REASON',
  ORDERS_REFETCH = 'ORDERS_REFETCH',
  ORDER_UPDATE_SEAT_NUMBER = 'ORDER_UPDATE_SEAT_NUMBER',

  // merge
  ORDER_INITIATE_MERGE = 'ORDER_INITIATE_MERGE',
  ORDER_MERGED = 'ORDER_MERGED',

  // Online Order Events
  ORDER_INITIATE_ONLINE = 'ORDER_INITIATE_ONLINE',
  ORDER_ACCEPT = 'ORDER_ACCEPT',
  ORDER_REJECT = 'ORDER_REJECT',
  ORDER_FIRE_ITEMS = 'ORDER_FIRE_ITEMS',
  ORDER_PRINT_KITCHEN_DOCKET = 'ORDER_PRINT_KITCHEN_DOCKET',
  ORDER_PARTNER_CANCEL = 'ORDER_PARTNER_CANCEL',
  ORDER_COMPLETE = 'ORDER_COMPLETE',
  ORDER_PLACED = 'ORDER_PLACED',
  ORDER_DUPLICATE = 'ORDER_DUPLICATE',

  ON_ACCOUNT_PAYMENT_TYPE = 'On Account',

  // CDS order event specific
  ORDER_CLOSE = 'ORDER_CLOSE',
  ORDER_OPEN = 'ORDER_OPEN',

  // Hold print
  ORDER_HOLD = 'ORDER_HOLD',
  REMOVE_ORDER_HOLD = 'REMOVE_ORDER_HOLD',

  // Transfer order items
  ORDER_TRANSFER_ITEMS = 'ORDER_TRANSFER_ITEMS',
  ORDER_TRANSFERRED_ITEMS = 'ORDER_TRANSFERRED_ITEMS',

  ORDER_TRANSFER_TABLES = 'ORDER_TRANSFER_TABLES',

  // checkout order locking
  ORDER_LOCK = 'ORDER_LOCK',
  ORDER_UNLOCK = 'ORDER_UNLOCK',

  // course specific
  ORDER_COURSE_CALLED = 'ORDER_COURSE_CALLED',
  ORDER_COURSE_UNCALLED = 'ORDER_COURSE_UNCALLED',
}

export enum OrderStatus {
  DRAFT = 'DRAFT',
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  VOID = 'VOID',
  REFUNDED = 'REFUNDED',
  COMPLETED = 'COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ON_ACCOUNT = 'ON_ACCOUNT',
  CANCELLED = 'CANCELLED',
  PARTNER_CANCELLED = 'PARTNER_CANCELLED',
  MERGED = 'MERGED',
}

export enum OrderItemStatus {
  DRAFT = 'DRAFT',
  CREATED = 'CREATED',
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
  REFUNDED = 'REFUNDED',
  COMPLETED = 'COMPLETED',
  VOID = 'VOID',
  IN_PROGRESS = 'IN_PROGRESS',
  MERGED = 'MERGED',
  TRANSFERRED = 'TRANSFERRED',
}

export enum VoidReason {
  WRONG_ORDER = 'WRONG_ORDER',
  CUSTOMER_UNHAPPY = 'CUSTOMER_UNHAPPY',
  CHANGE_OF_MIND = 'CHANGE_OF_MIND',
  NOT_PREPARED = 'NOT_PREPARED',
  STAFF_ERROR = 'STAFF_ERROR',
  WASTAGE = 'WASTAGE',
  LOST_TABLE = 'LOST_TABLE',
  FOOD_TASTING = 'FOOD_TASTING',
  PRODUCT_DAMAGED = 'PRODUCT_DAMAGED',
  WRONG_PRODUCT = 'WRONG_PRODUCT',
  PRODUCT_EXCHANGED = 'PRODUCT_EXCHANGED',
  TESTING_OR_TRAINING = 'TESTING_OR_TRAINING',
  COMPLIMENTARY = 'COMPLIMENTARY',
  OTHER = 'OTHER',
}

export enum RejectionReason {
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  CLOSED = 'CLOSED',
  TOO_BUSY = 'TOO_BUSY',
  TOO_FAR_AWAY = 'TOO_FAR_AWAY',
  INVALID_ITEM = 'INVALID_ITEM',
  INVALID_ITEM_SURCOUNT = 'INVALID_ITEM_SURCOUNT',
  INVALID_ITEM_OPTION = 'INVALID_ITEM_OPTION',
  INVALID_ITEM_VARIANT = 'INVALID_ITEM_VARIANT',
  INVALID_ORDER_SURCOUNT = 'INVALID_ORDER_SURCOUNT',
  WRONG_ITEM_PRICE = 'WRONG_ITEM_PRICE',
  WRONG_ITEM_TOTAL_BEFORE_SURCOUNTS = 'WRONG_ITEM_TOTAL_BEFORE_SURCOUNTS',
  WRONG_ITEM_TOTAL_AFTER_SURCOUNTS = 'WRONG_ITEM_TOTAL_AFTER_SURCOUNTS',
  WRONG_ITEM_SURCOUNT_VALUE = 'WRONG_ITEM_SURCOUNT_VALUE',
  WRONG_ITEM_VARIANT_VALUE = 'WRONG_ITEM_VARIANT_VALUE',
  WRONG_ORDER_SURCOUNT_VALUE = 'WRONG_ORDER_SURCOUNT_VALUE',
}

export enum NotificationMode {
  EMAIL_AND_PHONE = 'EMAIL_AND_PHONE',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export enum NotificationType {
  SEND_RECEIPT_AND_MESSAGE = 'SEND_RECEIPT_AND_MESSAGE',
  SEND_RECEIPT = 'SEND_RECEIPT',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SEND_KDS_MESSAGE = 'SEND_KDS_MESSAGE',
  SEND_ORDER_STATUS_UPDATE = 'SEND_ORDER_STATUS_UPDATE',
  SEND_PAYMENT_LINK = 'SEND_PAYMENT_LINK',
}

export enum OrderTypeCode {
  CATERING = 'C',
  DELIVERY = 'DL',
  DINE_IN = 'D',
  PICK_UP = 'P',
  TAKEAWAY = 'T',
}

export const ORDERS_LIMIT = 50;

export enum OrderPaymentStatus {
  REQUESTED = 'REQUESTED',
  PENDING = 'PENDING',
  PART_PAID = 'PART_PAID',
  WAITING = 'WAITING',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  REFUND_IN_PROGRESS = 'REFUND_IN_PROGRESS',
  SENT_FOR_REFUND = 'SENT_FOR_REFUND',
  REFUND_FAILED = 'REFUND_FAILED',
  COMPLETE = 'COMPLETE',
  // Outcome unverifiable — terminal/gateway did not respond. See INC-691.
  UNKNOWN = 'UNKNOWN',
}

export enum OrderTransferType {
  ITEMS = 'ITEMS',
  TABLES = 'TABLES',
}

export enum PartnerCode {
  UberEats = 'ubereats',
  Menulog = 'menulog',
  Doordash = 'doordash',
  GoogleFood = 'googlefood',
  Online = 'online',
  Deliverit = 'deliverit',
  Giftcard = 'giftcard',
}
